import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class EmailService {

  private url = '//services.focustextil.com.br/node/servicesctrl_dev/contato/comercial';
  // private url = 'http://189.126.197.169/node/servicesctrl_dev/contato/comercial';

  constructor(private http: HttpClient) { }

  contato(query: any): Observable<any> {
    const requestOptions: Object = {
      responseType: 'text'
    }
    let response = this.http.post<any>(
      this.url,
      {
        cidade: query.cidade,
        cnpj: query.cnpj,
        email: query.email,
        empresa: query.empresa,
        estado: query.estado,
        funcao: query.funcao,
        mensagem: query.mensagem,
        nome: query.nome,
        tel: query.tel

      },
      requestOptions
    );
    return response;
  }
}
